import './Leads.scss';

import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import leadsModel from '../../../../model/leads';
import {leadTypes} from './LeadsList';
import withRouter from '/src/components/misc/withRouter';

class LeadComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      lead: null,
      leadId: props.match.params.leadId,
      hasResponse: false,
      responseObj: null,
      waitingForAjax: false,
      resendResponse: null
    };

    this.initializedJson = false;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.ignoreLead = this.ignoreLead.bind(this);
    this.unignoreLead = this.unignoreLead.bind(this);
    this.printIgnoreButton = this.printIgnoreButton.bind(this);
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    this.fetchLead();
  }

  componentDidUpdate() {
    const propLeadId = parseInt(this.props.match.params.leadId, 10);
    if (this.state.lead && this.state.lead.id !== propLeadId) {
      this.setState({
        lead: null,
        leadId: propLeadId,
        hasResponse: false,
        responseObj: null,
        waitingForAjax: false,
        resendResponse: null
      }, () => {
        this.fetchLead();
      });
      return;
    }

    if (!this.initializedJson && this.state.lead) {
      this.refJson.value = JSON.stringify(this.state.lead.formData, null, 4);
      this.initializedJson = true;
    }
  }

  fetchLead() {
    leadsModel.getById(this.props.match.params.leadId).then((lead) => {
      document.title = `Admin - Leads - ${lead.id}`;
      this.setState({
        lead
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  handleDataChange() {

  }

  ignoreLead(e) {
    e.preventDefault();

    this.setState({
      waitingForAjax: true
    });

    leadsModel.ignore(this.state.lead.id).then((lead) => {
      this.setState({
        waitingForAjax: false,
        lead: lead
      });
    });
  }

  unignoreLead(e) {
    e.preventDefault();

    this.setState({
      waitingForAjax: true
    });

    leadsModel.unignore(this.state.lead.id).then((lead) => {
      this.setState({
        waitingForAjax: false,
        lead: lead
      });
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const jsonText = this.refJson.value;
    let data;

    try {
      data = JSON.parse(jsonText);
    } catch (e) {
      console.error(e);
      data = false;
    }

    if (!data) {
      console.error('Invalid JSON');
      this.setState({
        hasResponse: true,
        responseObj: {error: 'Invalid JSON'},
        waitingForAjax: false
      });

      return false;
    }

    this.setState({
      hasResponse: false,
      responseObj: {},
      waitingForAjax: true
    });

    data.formType = this.state.lead.type;

    leadsModel.save(data).then((response) => {
      this.setState({
        hasResponse: false,
        responseObj: response,
        waitingForAjax: false,
        resendResponse: response.data
      });
    }).catch((result) => {
      if (result.status === 400) {
        result.json().then((response) => {
          if (response && response.error === 'Invalid data') {
            if (response.data && response.data.length) {
              this.setState({
                hasResponse: true,
                responseObj: {error: 'Invalid data', data: response.data},
                waitingForAjax: false
              });

              return;
            }
          }
        }).catch(() => {});
      }

      this.setState({
        hasResponse: true,
        responseObj: {error: 'Error', data: result.statusText},
        waitingForAjax: false
      });
    });
  }

  printIgnoreButton(leadSuccessful, isIgnored) {
    if (leadSuccessful && !isIgnored) {
      return;
    }

    if (isIgnored) {
      return <a href="#" className="btn btn-success" onClick={this.unignoreLead}>Vis i overvåkning</a>;
    }

    return <a href="#" className="btn btn-danger" onClick={this.ignoreLead}>Ignorer i overvåkning</a>;
  }

  render() {
    if (!this.state.lead) {
      return (
        <h1>404</h1>
      );
    }

    const lead = this.state.lead;
    const dateString = (new Date(lead.created * 1000)).toLocaleString();
    const leadSuccessful = lead.success;
    // Spam leads have ignore = 1 by default, but to be ignored in xymon spam check this needs to be 2
    const leadIgnored = lead.ignore && (lead.error !== 'spam' || lead.ignore === 2);

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <h1 className="page-header">Leads</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <section className="panel panel-default">
              <div className="panel-heading">
                <strong><i className="fa fa-pencil"/> Innsendt lead ({lead.id})</strong>
              </div>

              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Opprettet</label>
                      <input type="text" className="form-control" value={dateString} disabled />
                    </div>
                    <div className="form-group">
                      <label>Skjema</label>
                      <input type="text" className="form-control" value={leadTypes[lead.type] || lead.type} disabled />
                    </div>
                    <div className={`form-group ${leadSuccessful ? 'has-success' : 'has-error'}` }>
                      <label>Innsendings status</label>
                      <input type="text" className="form-control" value={(leadSuccessful ? 'Innsendt' : 'Feilet')} disabled />
                    </div>
                    <div className="form-group">
                      {this.printIgnoreButton(leadSuccessful, leadIgnored)}
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <section className={`panel panel-default ${leadSuccessful ? 'panel-success' : 'panel-danger'}`}>
                      <div className="panel-heading" role="tab" id="heading-details">
                        <strong><i className="fa fa-info"/> Status detaljer</strong>
                      </div>
                      <div className="panel-body">
                        <div className="form-group">
                          <label>HTTP svar</label>
                          <input type="text" className="form-control" value={lead.httpCode} disabled />
                        </div>
                        <div className="form-group">
                          <label>Status kode</label>
                          <input type="text" className="form-control" value={lead.postCode} disabled />
                        </div>
                        <div className="form-group">
                          <label>Resultat</label>
                          <input type="text" className="form-control" value={lead.postResult} disabled />
                        </div>
                        <div className="form-group">
                          <label>Result raw</label>
                          <textarea rows="3" className="form-control" readOnly value={lead.result}></textarea>
                        </div>
                        <div className="form-group">
                          <label>Error</label>
                          <input type="text" className="form-control" value={lead.error || ''} disabled />
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Skjema data</label>
                      <textarea rows="20" ref={(ref) => (this.refJson = ref)} className="form-control"></textarea>
                      <p className="help-block">Innsendt skjema fra web.</p>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>POST data</label>
                      <textarea rows="20" className="form-control" readOnly value={JSON.stringify(lead.postData, null, 4)}></textarea>
                      <p className="help-block">Data sendt videre til server.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="panel-body">
                <div className="form-group">
                  <a href="#" className={`btn btn-warning ${this.state.waitingForAjax ? 'disabled' : ''}`} onClick={this.handleSubmit}>Send igjen</a>
                  <p className="help-block">Sender inn verdien fra &quot;Skjema data&quot; til server, dette lagres som et nytt lead.</p>
                </div>
              </div>
              <div className="panel-body">
                <div className={`form-group ${this.state.hasResponse ? 'show' : 'hide'}`}>
                  <label>Resend svar</label>
                  <textarea rows="10" className="form-control" readOnly value={JSON.stringify(this.state.responseObj, null, 4)}></textarea>
                </div>
              </div>
              <div className={`panel-body ${this.state.resendResponse ? '' : 'hide'}`}>
                <div className="form-group">
                  <div className="btn-toolbar">
                    <Link className="btn btn-success" to={`/leads/lead/${this.state.resendResponse?.id}`}>Gå til nytt lead</Link>
                    {this.printIgnoreButton(leadSuccessful, leadIgnored, lead.error === 'spam')}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LeadComponent);
